import { lazy } from 'react';
import { type RouteObject, useParams } from 'react-router';
import { useShippingProviderDetailsQuery } from '~/domain/shipping-provider/api';

const CreatePage = lazy(() => import('./pages/create'));

export default {
    path: ':providerId/parcels',
    Title: () => {
        const { providerId } = useParams<{ providerId: string }>();
        const { data } = useShippingProviderDetailsQuery(providerId!, { skip: !providerId });
        return data ? data.name : null;
    },
    children: [{
        path: 'create',
        Component: CreatePage,
    }],
} satisfies RouteObject;
